import { useQuery, useMutation } from '@tanstack/react-query';

import { fetchCharacters, fetchPermissions, fetchCharacter, fetchCharacterInventory, fetchCharacterVehicles, fetchVehicles, fetchVehicle, fetchBans, fetchForbes, fetchServerStatus } from '../service/api';

export function useGetServerStatus() {
  const { data, isFetching, isSuccess, isError } = useQuery({
    queryKey: ['server_status'],
    queryFn: fetchServerStatus,
  });

  return { isSuccess, isError, isFetching, data };
}

export function useGetAdmin() {
  const { data, isFetching, error, refetch } = useQuery({
    queryKey: ['news'],
    queryFn: fetchCharacters,
  });

  return { data, isFetching, error, refetch };
};

export function useGetBans() {
  const { data, isFetching, error, refetch } = useQuery({
    queryKey: ['bans'],
    queryFn: fetchBans,
  });

  return { data, isFetching, error, refetch };
};

export function useGetCharacters() {
  const { data, isError, isFetching } = useQuery({
    queryKey: ['characters'],
    queryFn: fetchCharacters,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    staleTime: 60000,
  });

  return { data, isError, isFetching };
}

export function useGetForbes() {
  const { data, isError, isFetching } = useQuery({
    queryKey: ['forbes'],
    queryFn: fetchForbes,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    staleTime: 60000,
  });

  return { data, isError, isFetching };
}

export function useGetVehicles() {
  const { data, isError, isFetching } = useQuery({
    queryKey: ['vehicles'],
    queryFn: fetchVehicles,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    staleTime: 60000,
  });

  return { data, isError, isFetching };
}

export function useGetCharacter(cid) {
  const { data, isError, isFetching } = useQuery({
    queryKey: [`character_${cid}`, { cid }],
    queryFn: () => fetchCharacter({ cid }),
  });

  return { data, isError, isFetching };
}

export function useGetVehicle(plate) {
  const { data, isError, isFetching } = useQuery({
    queryKey: [`vehicle_${plate}`, { plate }],
    queryFn: () => fetchVehicle({ plate }),
  });

  return { data, isError, isFetching };
}

export function useGetCharacterInventory(cid) {
  const { data, isError, isFetching } = useQuery({
    queryKey: [`character_inv_${cid}`, { cid }],
    queryFn: () => fetchCharacterInventory({ cid }),
    keepPreviousData: true,
    staleTime: 60000,
  });

  return { data, isError, isFetching };
}

export function useGetCharacterVehicles(cid) {
  const { data, isError, isFetching } = useQuery({
    queryKey: [`character_veh_${cid}`, { cid }],
    queryFn: () => fetchCharacterVehicles({ cid }),
    keepPreviousData: true,
    staleTime: 60000,
  });

  return { data, isError, isFetching };
}

export function useGetPermissions() {
  const { data, isError, isFetching } = useQuery({
    queryKey: ['permissions_a'],
    queryFn: fetchPermissions,
    keepPreviousData: true,
    staleTime: 60000,
  });

  return { data, isError, isFetching };
}